import React from 'react'
import { getStaticBaseUrl } from '../../stores/configStore'
import Button from '../ui-kit/Button'

function NewsBlock({ news }) {
  const date = news?.date ? new Date(news.date) : null;
  return (
    <div className='NewsBlock'>
        <div className="image">
            {news?.image ? (
              <img src={`${getStaticBaseUrl()}${news.image}`} alt="news" />
            ) : (
              <img src="https://cdn-imgix-open.headout.com/fallback/landscape.svg?w=1188&h=742.5&fm=svg&auto=compress%2Cformat&fit=min" alt="" />
            )}

            <div className="body">
                <div className="date">
                    {date ? date.toLocaleString('ru-RU', { day: '2-digit', month: 'long', hour: '2-digit', minute: '2-digit' }) : ''}
                </div>

                <div className="title">
                    {news?.title}
                </div>

                <div className="text">
                    {news?.text?.slice(0, 180)}{news?.text?.length > 180 ? '...' : ''}
                </div>

                <div className="buttongo">
                    <Button text="Открыть полностью" href={`/news/${news?._id}`} />
                </div>
            </div>
        </div>
    </div>
  )
}

export default NewsBlock